// Central data source for Notes & Project Docs.
// Add a new object here to publish a new note — it will automatically
// show up on /notes and get its own page at /notes/:slug

const notes = [
  {
    slug: "loop-engineering-basics",
    title: "Loop Engineering — A Beginner's Guide",
    category: "note", // "note" | "doc"
    tags: ["AI", "Prompting", "BuildBytes"],
    summary:
      "What Loop Engineering means, why it matters for working with LLMs, and how to start applying it in your own prompts.",
    content: `
Loop Engineering is about designing feedback loops between you and an AI system,
instead of treating a prompt as a single one-shot request.

Why it matters:
- Most real problems need iteration, not a single perfect prompt.
- A good loop catches mistakes early instead of late.
- It turns AI usage into a repeatable process instead of trial and error.

A simple starter loop:
1. Draft — write your first attempt at the prompt or task.
2. Check — ask the model to review its own output against your goal.
3. Refine — feed corrections back in as new context, not a new conversation.
4. Repeat — until the output is stable and predictable.

This is the same mental model used in the BuildBytes Reel — start small,
build the loop, then scale it into your workflow.
    `,
  },
  {
    slug: "context-engineering-101",
    title: "Context Engineering 101",
    category: "note",
    tags: ["AI", "LLM", "BuildBytes"],
    summary:
      "How to think about what information you feed an LLM, and why context quality matters more than prompt cleverness.",
    content: `
Context Engineering is the practice of deciding exactly what information an AI
model sees before it responds — and what it doesn't.

Key ideas:
- More context isn't always better — irrelevant context dilutes attention.
- Structure matters: clearly separated sections beat one big paragraph.
- Order matters: put the most important instructions close to the question.

A practical checklist before you prompt:
- What does the model actually need to know to answer this?
- What can I remove without losing accuracy?
- Is anything ambiguous that I can clarify up front?

This is the foundation behind most of the "why is my AI output wrong" problems —
usually it's a context problem, not a model problem.
    `,
  },
  {
    slug: "workpulse-architecture",
    title: "WorkPulse — System Architecture Notes",
    category: "doc",
    tags: ["AWS", "Serverless", "Project"],
    summary:
      "Technical breakdown of WorkPulse, a workforce management platform built on AWS Lambda, API Gateway, and S3.",
    content: `
WorkPulse is a workforce management platform designed around a serverless
AWS architecture for scalability and low operating cost.

Core components:
- API Gateway — routes all client requests to backend Lambda functions.
- AWS Lambda — stateless compute for business logic (attendance, scheduling, reporting).
- S3 — storage for documents, exports, and static assets.
- DynamoDB — primary data store for workforce and scheduling records.

Design decisions:
- Serverless-first to avoid managing servers for variable workloads.
- Clear separation between API layer and business logic for easier testing.
- Event-driven patterns for background tasks like report generation.

This project is a core reference point in my resume and interviews —
this doc is the fuller technical version of that story.
    `,
  },
  {
    // Notes with a `driveLink` (and no `content`) open the external
    // document directly in a new tab instead of an internal /notes/:slug page.
    slug: "my-drive-note-1",
    title: "My Notes (Full Doc)",
    category: "note",
    tags: ["Notes"],
    summary: "Full write-up available as a document — tap to open.",
    driveLink:
      "https://drive.google.com/file/d/1CTmsrSz-F82VIXiPBXvSpS2XMpulP0B0/view?usp=sharing",
  },
];

export default notes;